import { Navigate } from 'react-router-dom';
import { isExpired } from 'react-jwt';
import { AESDecryption } from '../../utils/Aes';

const RequireNoAuth = ({ children }) => {
    const tokenEncrypted = localStorage.getItem('token');
    if (!tokenEncrypted) {
        return children;
    }

    const token = AESDecryption(tokenEncrypted);
    if (!token || isExpired(token)) {
        return children;
    }

    return <Navigate to="/dashboard" replace />;
};

export default RequireNoAuth;
